import { render, staticRenderFns } from "./EditPurchAddress.vue?vue&type=template&id=333cbfce"
import script from "./EditPurchAddress.vue?vue&type=script&lang=js"
export * from "./EditPurchAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports